<template>
  <div class="add-player">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-left" @click="goBack">
        <van-icon name="arrow-left" />
        <span>返回</span>
      </div>
      <div class="header-title">添加球员</div>
      <div class="header-actions">
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          class="home-link"
        >
          <van-icon name="wap-home" size="18" />
        </a>
        <div class="header-right" @click="savePlayer">
          <span>保存</span>
        </div>
      </div>
    </div>

    <!-- 表单内容 -->
    <div class="form-container">
      <!-- 头像上传区域 -->
      <div class="avatar-section">
        <div class="avatar-title">球员头像</div>
        <div class="avatar-upload" @click="chooseAvatar">
          <div v-if="playerInfo.IMGPATH" class="avatar-preview">
            <van-image
              :src="playerInfo.IMGPATH"
              width="100px"
              height="100px"
              round
              fit="cover"
            />
            <div class="avatar-overlay">
              <van-icon name="camera-o" />
              <span>更换头像</span>
            </div>
          </div>
          <div v-else class="avatar-placeholder">
            <van-icon name="plus" />
            <span>点击上传头像</span>
          </div>
        </div>
        <div class="avatar-tips">支持JPG、PNG格式，建议尺寸200x200像素</div>
      </div>

      <!-- 基础信息表单 -->
      <div class="form-section">
        <div class="section-title">基础信息</div>

        <!-- 姓名 -->
        <van-field
          v-model="playerInfo.RYXM"
          label="姓名"
          placeholder="请输入球员姓名"
          required
          :error="errors.RYXM"
          :error-message="errors.RYXM"
          clearable
        />

        <!-- 证件号 -->
        <van-field
          v-model="playerInfo.SFZH"
          label="证件号"
          placeholder="请输入身份证号码"
          required
          :error="errors.SFZH"
          :error-message="errors.SFZH"
          clearable
          maxlength="18"
        />

        <!-- 性别选择 -->
        <van-field
          v-model="genderText"
          is-link
          readonly
          label="性别"
          placeholder="请选择性别"
          required
          :error="errors.XB"
          :error-message="errors.XB"
          @click="showGenderPicker = true"
        />

        <!-- 出生日期 -->
        <van-field
          v-model="birthdateText"
          is-link
          readonly
          label="出生日期"
          placeholder="请选择出生日期"
          required
          :error="errors.CSRQ"
          :error-message="errors.CSRQ"
          @click="showDatePicker = true"
        />

        <!-- 开始打球日期 -->
        <van-field
          v-model="startPlayDateText"
          is-link
          readonly
          label="开始打球日期"
          placeholder="请选择开始打球日期"
          :error="errors.DQKSRQ"
          :error-message="errors.DQKSRQ"
          @click="showStartPlayDatePicker = true"
        />

        <!-- 联系电话 -->
        <van-field
          v-model="playerInfo.TEL"
          label="联系电话"
          placeholder="请输入联系电话"
          type="tel"
          required
          :error="errors.TEL"
          :error-message="errors.TEL"
          clearable
          maxlength="11"
        />

        <!-- 俱乐部名称 -->
        <van-field
          v-model="playerInfo.SYJLB"
          label="俱乐部"
          placeholder="请输入俱乐部名称（选填）"
          :error="errors.SYJLB"
          :error-message="errors.SYJLB"
          clearable
        />

        <!-- 球员等级 -->
        <van-field
          v-model="levelText"
          is-link
          readonly
          label="球员等级"
          placeholder="请选择球员等级"
          :error="errors.QYDJ"
          :error-message="errors.QYDJ"
          @click="showLevelPicker = true"
        />

        <!-- 所在城市 -->
        <van-field
          v-model="playerInfo.CITY"
          label="所在城市"
          placeholder="请输入所在城市（选填）"
          clearable
        />

        <!-- 最好成绩 -->
        <van-field
          v-model="playerInfo.ZHCJ"
          label="最好成绩"
          placeholder="请输入取得过的最好成绩（选填）"
          clearable
        />
      </div>

      <!-- 隐私设置 -->
      <div class="form-section">
        <div class="section-title">隐私设置</div>

        <!-- 已隐藏：允许查看个人主页 -->
        <van-cell title="允许查看个人主页" border>
          <template #right-icon>
            <van-switch
              v-model="allowViewProfileSwitch"
              size="24px"
              active-color="#185f9b"
              inactive-color="#ddd"
            />
          </template>
        </van-cell>

        <van-cell title="对外显示头像" :border="false">
          <template #right-icon>
            <van-switch
              v-model="showAvatarSwitch"
              size="24px"
              active-color="#185f9b"
              inactive-color="#ddd"
            />
          </template>
        </van-cell>

        <div class="privacy-tips">
          <van-icon name="info-o" />
          <span>开启"对外显示头像"后，头像将在公开场合显示</span>
        </div>
      </div>

      <!-- 备注信息 -->
      <div class="form-section">
        <div class="section-title">备注信息</div>

        <van-field
          v-model="playerInfo.BZ"
          label="备注"
          type="textarea"
          placeholder="请输入备注信息（选填）"
          rows="3"
          autosize
          maxlength="200"
          show-word-limit
        />
      </div>

      <!-- 保存按钮 -->
      <div class="save-section">
        <van-button
          type="primary"
          size="large"
          block
          :loading="saving"
          @click="savePlayer"
        >
          {{ saving ? "保存中..." : "保存球员信息" }}
        </van-button>
      </div>
    </div>

    <!-- 性别选择器 -->
    <van-popup v-model="showGenderPicker" position="bottom" round>
      <van-picker
        :columns="genderOptions"
        @confirm="onGenderConfirm"
        @cancel="showGenderPicker = false"
        title="选择性别"
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
      />
    </van-popup>

    <!-- 日期选择器 -->
    <van-popup v-model="showDatePicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择出生日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <!-- 开始打球日期选择器 -->
    <van-popup v-model="showStartPlayDatePicker" position="bottom" round>
      <van-datetime-picker
        v-model="currentStartPlayDate"
        type="date"
        title="选择开始打球日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onStartPlayDateConfirm"
        @cancel="showStartPlayDatePicker = false"
      />
    </van-popup>

    <!-- 球员等级选择器 -->
    <van-popup v-model="showLevelPicker" position="bottom" round>
      <van-picker
        :columns="levelOptions"
        @confirm="onLevelConfirm"
        @cancel="showLevelPicker = false"
        title="选择球员等级"
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
      />
    </van-popup>

    <!-- 头像上传组件 -->
    <input
      ref="avatarInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="handleAvatarUpload"
    />

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "AddPlayer",

  data() {
    return {
      saving: false,
      routeValue: "", // 路由值
      showGenderPicker: false,
      showDatePicker: false,
      showStartPlayDatePicker: false,
      showLevelPicker: false,

      // 球员信息 - 字段名对应数据库字段
      playerInfo: {
        RYXM: "", // 姓名
        SFZH: "", // 身份证号
        XB: "", // 性别
        SYJLB: "", // 俱乐部名称
        CITY: "", // 所在城市
        IMGPATH: "", // 头像路径
        CSRQ: "", // 出生日期yyyy-MM-dd
        DQKSRQ: "", // 开始打球的日期
        TEL: "", // 联系电话
        QYDJ: "", // 球员等级
        ZHCJ: "", // 最好成绩
        ISZY: "Y", // 是否允许查看个人主页 (Y/N)
        ISTX: "Y", // 是否显示个人头像 (Y/N)
        BZ: "", // 备注
        type: "ADD",
        RYID: ""
      },

      // 表单验证错误
      errors: {},

      // 头像上传信息
      avatarInfo: null,

      // 日期相关
      currentDate: new Date(),
      currentStartPlayDate: new Date(),
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(),

      // 选择器选项
      genderOptions: [
        { text: "男", value: "M" },
        { text: "女", value: "W" }
      ],

      levelOptions: [
        { text: "初级", value: "初级" },
        { text: "中级", value: "中级" },
        { text: "高级", value: "高级" },
        { text: "专业", value: "专业" },
        { text: "国家级", value: "国家级" }
      ]
    };
  },

  computed: {
    genderText() {
      const option = this.genderOptions.find(
        item => item.value === this.playerInfo.XB
      );
      return option ? option.text : "";
    },

    birthdateText() {
      return this.playerInfo.CSRQ ? this.formatDate(this.playerInfo.CSRQ) : "";
    },

    startPlayDateText() {
      return this.playerInfo.DQKSRQ
        ? this.formatDate(this.playerInfo.DQKSRQ)
        : "";
    },

    levelText() {
      const option = this.levelOptions.find(
        item => item.value === this.playerInfo.QYDJ
      );
      return option ? option.text : "";
    },

    // 允许查看个人主页开关
    allowViewProfileSwitch: {
      get() {
        return this.playerInfo.ISZY === "Y";
      },
      set(value) {
        this.playerInfo.ISZY = value ? "Y" : "N";
      }
    },

    // 对外显示头像开关
    showAvatarSwitch: {
      get() {
        return this.playerInfo.ISTX === "Y";
      },
      set(value) {
        this.playerInfo.ISTX = value ? "Y" : "N";
      }
    }
  },

  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    const openIdEn = localStorage.getItem("openIdEn");
    if (!openIdEn) {
      this.$router.push("/loginIndex");
      return;
    }
    const ryInfoLocal = localStorage.getItem("ryInfo");
    if (!ryInfoLocal) this.$router.push("/loginIndex");

    // 检查是否为编辑模式
    this.checkEditMode();
  },
  methods: {
    // 检查并处理编辑模式
    checkEditMode() {
      const query = this.$route.query;

      if (query.mode === "edit") {
        // 编辑模式，填充数据
        this.playerInfo.type = "UPT";

        // 填充基本信息
        if (query.sfzh) this.playerInfo.SFZH = query.sfzh;
        if (query.ryxm) this.playerInfo.RYXM = query.ryxm;
        if (query.txurl) this.playerInfo.IMGPATH = query.txurl;
        if (query.xb) this.playerInfo.XB = query.xb;
        if (query.qydj) this.playerInfo.QYDJ = query.qydj;
        if (query.ryid) this.playerInfo.RYID = query.ryid;

        // 更新页面标题
        const headerTitle = document.querySelector(".header-title");
        if (headerTitle) {
          headerTitle.textContent = "编辑球员信息";
        }

        // 如果有身份证号，可以调用接口获取完整信息
        if (query.ryid) {
          this.loadPlayerFullInfo(query.ryid);
        }
      }
    },

    // 加载球员完整信息
    async loadPlayerFullInfo(ryid) {
      try {
        const paramData = {
          headerData: {
            ssid: "",
            op: "wapGL",
            methodName: "getPlayerInfo"
          },
          busData: {
            RYID: ryid
          }
        };

        this.utilPost.paramData = paramData;
        const response = await this.utilPost.sendPost();

        if (response.isSuccess && response.content) {
          const data = response.content;

          // 填充所有字段
          this.playerInfo.RYXM = data.RYXM || "";
          this.playerInfo.SFZH = data.SFZH || "";
          this.playerInfo.XB = data.XB || "";
          this.playerInfo.SYJLB = data.SYJLB || "";
          this.playerInfo.CITY = data.CITY || "";
          this.playerInfo.IMGPATH = data.TXURL || "";
          this.playerInfo.CSRQ = data.CSRQ || "";
          this.playerInfo.DQKSRQ = data.DQKSRQ || "";
          this.playerInfo.TEL = data.TEL || "";
          this.playerInfo.QYDJ = data.QYDJ || "";
          this.playerInfo.ZHCJ = data.ZHCJ || "";
          this.playerInfo.ISZY = data.ISZY || "Y";
          this.playerInfo.ISTX = data.ISTX || "Y";
          this.playerInfo.BZ = data.BZ || "";
          this.playerInfo.RYID = data.RYID || "";

          // 设置日期选择器的当前值
          if (data.CSRQ) {
            this.currentDate = new Date(data.CSRQ);
          }
          if (data.DQKSRQ) {
            this.currentStartPlayDate = new Date(data.DQKSRQ);
          }
        }
      } catch (error) {
        console.error("加载球员信息失败:", error);
      }
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 选择头像
    chooseAvatar() {
      this.$refs.avatarInput.click();
    },

    // 处理头像上传
    handleAvatarUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型
      if (!file.type.startsWith("image/")) {
        this.$toast("请选择图片文件");
        return;
      }

      // 验证文件大小 (2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.$toast("图片大小不能超过2MB");
        return;
      }

      // 先创建本地预览
      const reader = new FileReader();
      reader.onload = e => {
        this.playerInfo.IMGPATH = e.target.result;
      };
      reader.readAsDataURL(file);

      // 上传图片到服务器
      this.uploadAvatar(file);

      // 清空input
      event.target.value = "";
    },

    // 上传头像到服务器
    uploadAvatar(file) {
      // 构建上传标识：类型々姓名々身份证号
      var radomInt = Math.floor(Math.random() * 10000);
      var sjcStr = radomInt + "";
      const uploadKey =
        "SyImages" +
        "々756d79786969496135505072746567736350515931673d3d々" +
        (this.playerInfo.RYXM || "TxImg") +
        "々" +
        (this.playerInfo.RYID || Date.now() + "" + sjcStr) +
        "々" +
        (this.playerInfo.RYID || Date.now() + "" + sjcStr);

      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0
      });

      // 构造 van-uploader 格式的文件对象
      const fileObj = {
        file: file, // 原始 File 对象
        content: null, // 可选：文件内容
        name: file.name, // 文件名
        type: file.type, // 文件类型
        size: file.size // 文件大小
      };

      this.utilPost
        .uploadImg(fileObj, uploadKey)
        .then(data => {
          this.$toast.clear();
          if (data.isSuccess) {
            // 上传成功，保存服务器返回的图片路径
            this.playerInfo.IMGPATH = data.content.url;
            // 可以保存更多信息用于后续处理
            this.avatarInfo = {
              url: data.content.url,
              filePath: data.content.filePath,
              filePath_ys: data.content.filePath_ys
            };
            this.$toast.success("头像上传成功");
          } else {
            this.$toast.fail(data.msg || "上传失败");
          }
        })
        .catch(error => {
          this.$toast.clear();
          console.error("上传失败:", error);
          this.$toast.fail("上传失败，请重试");
        });
    },

    // 性别选择确认
    onGenderConfirm(value, index) {
      // van-picker 的确认回调会传递选中的值和索引
      this.playerInfo.XB = value.value || value;
      this.showGenderPicker = false;
      this.clearError("XB");
    },

    // 日期选择确认
    onDateConfirm(value) {
      this.playerInfo.CSRQ = value;
      this.showDatePicker = false;
      this.clearError("CSRQ");
    },

    // 开始打球日期选择确认
    onStartPlayDateConfirm(value) {
      this.playerInfo.DQKSRQ = value;
      this.showStartPlayDatePicker = false;
      this.clearError("DQKSRQ");
    },

    // 球员等级选择确认
    onLevelConfirm(value, index) {
      // van-picker 的确认回调会传递选中的值和索引
      this.playerInfo.QYDJ = value.value || value;
      this.showLevelPicker = false;
      this.clearError("QYDJ");
    },

    // 格式化日期
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 清除某个字段的错误
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },

    // 验证身份证号：带*直接通过，否则校验格式
    validateIdNumber(idNumber) {
      // 如果包含 * 号，直接返回 true 通过
      if (idNumber && idNumber.includes("*")) {
        return true;
      }
      // 不包含 * 才走正常格式校验
      const regex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return regex.test(idNumber);
    },

    // 验证手机号
    validatePhone(phone) {
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(phone);
    },

    // 表单验证
    validateForm() {
      this.errors = {};

      // 姓名验证
      if (!this.playerInfo.RYXM.trim()) {
        this.errors.RYXM = "请输入球员姓名";
      } else if (this.playerInfo.RYXM.trim().length < 2) {
        this.errors.RYXM = "姓名至少2个字符";
      }

      // 证件号验证
      if (!this.playerInfo.SFZH.trim()) {
        this.errors.SFZH = "请输入证件号";
      } else if (!this.validateIdNumber(this.playerInfo.SFZH)) {
        this.errors.SFZH = "证件号格式不正确";
      }

      // 性别验证
      if (!this.playerInfo.XB) {
        this.errors.XB = "请选择性别";
      }

      // 出生日期验证
      if (!this.playerInfo.CSRQ) {
        this.errors.CSRQ = "请选择出生日期";
      }

      // 开始打球日期验证
      if (this.playerInfo.DQKSRQ) {
        const startPlayDate = new Date(this.playerInfo.DQKSRQ);
        const birthDate = new Date(this.playerInfo.CSRQ);
        const currentDate = new Date();

        if (startPlayDate < birthDate) {
          this.errors.DQKSRQ = "开始打球日期不能早于出生日期";
        } else if (startPlayDate > currentDate) {
          this.errors.DQKSRQ = "开始打球日期不能晚于当前日期";
        }
      }

      // 手机号验证
      if (!this.playerInfo.TEL.trim()) {
        this.errors.TEL = "请输入联系电话";
      } else if (!this.validatePhone(this.playerInfo.TEL)) {
        this.errors.TEL = "手机号格式不正确";
      }

      return Object.keys(this.errors).length === 0;
    },

    // 保存球员信息
    async savePlayer() {
      if (!this.validateForm()) {
        this.$toast("请完善必填信息");
        return;
      }

      this.saving = true;

      try {
        // 构建提交数据
        const submitData = {
          ...this.playerInfo,
          CSRQ: this.playerInfo.CSRQ
            ? this.formatDate(this.playerInfo.CSRQ)
            : "",
          DQKSRQ: this.playerInfo.DQKSRQ
            ? this.formatDate(this.playerInfo.DQKSRQ)
            : "",
          createTime: new Date().toISOString()
        };

        // 这里调用实际的保存接口
        const response = await this.savePlayerInfo(submitData);
        if (!response.isSuccess) {
          alert(response.msg);
          return;
        }
        // 模拟保存过程
        await new Promise(resolve => setTimeout(resolve, 1500));

        this.$toast.success("球员信息保存成功");

        // 保存成功后返回上一页
        setTimeout(() => {
          this.goBack();
        }, 1000);
      } catch (error) {
        console.error("保存失败:", error);
        this.$toast.fail("保存失败，请重试");
      } finally {
        this.saving = false;
      }
    },

    // 保存球员信息到服务器（示例方法）
    async savePlayerInfo(data) {
      const paramData = {
        headerData: {
          ssid: "",
          op: "wapGl",
          methodName: "addPlayer"
        },
        busData: data
      };

      this.utilPost.paramData = paramData;
      return await this.utilPost.sendPost();
    }
  }
};
</script>

<style scoped>
.add-player {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部导航栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #185f9b;
  font-size: 16px;
  cursor: pointer;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.home-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #185f9b;
  transition: all 0.3s ease;
}

.home-link:hover {
  transform: scale(1.1);
  color: #667eea;
}

.header-right {
  color: #185f9b;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.header-right:active {
  opacity: 0.7;
}

/* 表单容器 */
.form-container {
  padding: 0 16px;
}

/* 头像上传区域 */
.avatar-section {
  background: #fff;
  padding: 20px;
  margin: 16px 0;
  border-radius: 12px;
  text-align: center;
}

.avatar-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.avatar-upload {
  display: inline-block;
  cursor: pointer;
  position: relative;
}

.avatar-preview {
  position: relative;
  display: inline-block;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.avatar-preview:hover .avatar-overlay {
  opacity: 1;
}

.avatar-overlay .van-icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.avatar-placeholder {
  width: 100px;
  height: 100px;
  border: 2px dashed #ddd;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
  transition: all 0.3s ease;
}

.avatar-placeholder:hover {
  border-color: #185f9b;
  color: #185f9b;
}

.avatar-placeholder .van-icon {
  font-size: 24px;
  margin-bottom: 4px;
}

.avatar-tips {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

/* 表单区域 */
.form-section {
  background: #fff;
  margin: 16px 0;
  border-radius: 12px;
  overflow: hidden;
}

/* 隐私提示样式 */
.privacy-tips {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  font-size: 12px;
  color: #666;
  background: #f8f9fa;
  border-top: 1px solid #f0f0f0;
}

.privacy-tips .van-icon {
  font-size: 14px;
  color: #999;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding: 16px 16px 0;
  margin-bottom: 8px;
}

.form-section .van-field {
  border-bottom: 1px solid #f5f5f5;
}

.form-section .van-field:last-child {
  border-bottom: none;
}

/* 保存按钮区域 */
.save-section {
  margin: 24px 0;
}

.save-section .van-button {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
}

.save-section .van-button--loading {
  background: #ccc;
}

/* 选择器样式 */
.van-popup {
  border-radius: 16px 16px 0 0;
}

.van-picker {
  border-radius: 16px 16px 0 0;
}

.van-datetime-picker {
  border-radius: 16px 16px 0 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .form-container {
    padding: 0 12px;
  }

  .avatar-section {
    margin: 12px 0;
    padding: 16px;
  }

  .form-section {
    margin: 12px 0;
  }

  .header {
    padding: 10px 12px;
  }

  .header-title {
    font-size: 16px;
  }

  .save-section {
    margin: 20px 0;
  }
}

/* 动画效果 */
.form-section {
  animation: slideInUp 0.4s ease-out;
}

.avatar-section {
  animation: fadeIn 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/AddPlayer.vue